import { Height, Margin, Padding } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FlexBoxForTaskMetricsFilters = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "20px",
}));

export const FlexBoxForClientAnalytics = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  marginBottom: "20px",
}));

export const Typography13 = styled(Typography)(() => ({
  opacity: "50%",
  fontSize: "13px",
  lineHeight: "16px",
}));


export const StyledTaskBox = styled(Box)({
  borderRadius: "10px",
  border: "1px solid #0000001A",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  "& header": {
    background: "rgba(0, 0, 0, 0.06)",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "& footer": {
    borderTop: "1px solid #0000001A",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    alignItems: "center",
  },
  "& main": {
    padding: "10px",
    flex: 1,
    overflowY: "auto",
  },
});

export const StyledOutStandingBox = styled(Box)({
  border: "1px solid  #0000001A",
  borderRadius: "10px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  "& header": {
    // background: "rgba(0, 0, 0, 0.06)",
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "space-between",
    // borderRadius: "10px",
    background: "rgba(0, 0, 0, 0.06)",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "& div": {
    background: "#EEF2F8",
    borderRadius: "10px",
    margin: 8
  }
})


export const StyledTaskBoxDemo = styled(Box)({
  borderRadius: "10px",
  border: "1px solid #0000001A",
  height: "100%",
  display: 'flex',
  flexDirection: "column",
  "& header": {
    background: "rgba(0, 0, 0, 0.06)",
    padding: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "& footer": {
    borderTop: "1px solid #0000001A",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    alignItmes: "center",

  },
  "& main": {
    Padding: "10px",
    flex: 1,
    overflowY: "auto",
    margin: "10px"


  }


});
export const DetailsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px; /* corresponds to gap: 2 in MUI spacing system */

  /* Responsive design for different screen sizes */
  @media (min-width: 600px) {
    flex-direction: row;
  }

  @media (min-width: 960px) {
    flex-direction: row;
    gap: 24px; /* Adjust gap for medium screens (md) */
  }

  @media (min-width: 1280px) {
    gap: 32px; /* Adjust gap for large screens (lg) */
  }
`;


export const ClientStyledButton = styled(Button)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;


  flex-direction: column; /* Default for xs */
  
  @media (min-width: 600px) {
    flex-direction: row; /* For sm screens */
  }

  @media (min-width: 960px) {
    flex-direction: row; /* For md screens */
  }

  @media (min-width: 1280px) {
    flex-direction: row; /* For lg screens */
  }
`;

export const StyledTypography = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1434A4;
  font-weight: bold;
  margin: 0;
  margin-top: 0;
  margin-bottom: 1rem;
  text-align: center;
`;